import { ComponentPropsWithoutRef } from 'react';
import { IonAccordion, IonAccordionGroup, IonItem, IonLabel, IonSegmentContent } from '@ionic/react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

type FaqsContentProps = ComponentPropsWithoutRef<typeof IonSegmentContent>;

const items = [
  'use_loyalty_and_coupon',
  'issue_with_order',
  'apply_promo_code',
  'loyalty_points',
  'pickup_instructions',
  'no_confirmation',
  'payment_methods',
  'cancel_or_edit_order',
  'track_order',
  'customize_order',
  'schedule_order',
  'how_to_place_order',
];

const FaqsContent = ({ className, ...rest }: FaqsContentProps) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:HelpAndFaq:FaqsContent' });

  return (
    <IonSegmentContent className={classnames('', className)} {...rest}>
      <IonAccordionGroup>
        {items.map((item) => (
          <IonAccordion key={item}>
            <IonItem
              slot="header"
              className="[&_.ion-accordion-toggle-icon]:text-gray-700 [&::part(native)]:pl-0 border-mobile-notice"
              style={{
                '--inner-padding-end': 0,
              }}
            >
              <IonLabel className="font-semibold !text-sm">{t(`${item}.header`)}</IonLabel>
            </IonItem>
            <div className="text-gray-700 text-xs font-medium pb-md" slot="content">
              {t(`${item}.body`)}
            </div>
          </IonAccordion>
        ))}
      </IonAccordionGroup>
    </IonSegmentContent>
  );
};

export default FaqsContent;
